module.exports = __webpack_public_path__ + "static/img/success.6fc37c82.png";